const validate = (values) => {
  const errors = {};

  if (!values.roomName || values.roomName.trim() === '') {
    errors.roomName = 'Please enter room name';
  }
  // if (!values.description) {
  //   errors.description = 'Please enter description';
  // }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/validate.js